import React from 'react'
import {Button } from 'antd';
import './finallyfound.css';
 

function Finally() {
  return (
    <div className='fin'>
      <p className='finally-head'>You’ve Finally Found the Right SEO Company With Answers</p>
      <p className='finally-subhead'>Brand's has the SEO solutions you’ve been searching for. Don’t let another day go by where your competitors are looking down on you! It’s time to be discovered!</p>
      <div className='btn'><Button className='button-seo'>INCREASE MY LEADS NOW</Button></div>
    </div>
  )
}

export default Finally;
